import React from "react";

const AdImageList = () => {
  return <div>AdImageList</div>;
};

export default AdImageList;
